<template>
  <section class="section mobile_div section_bg first_page">
    <loading-block v-if="is_load==false" :loading="!is_load"/>


     <div v-if="is_load" class="section_header mobile_div d-flex justify-content-center ">
        <nav aria-label="breadcrumb"    >
          <ol class="breadcrumb">
             <li class="breadcrumb-item"><router-link tag="a" to="/invoices" >Счета</router-link></li>


            <li class="breadcrumb-item active" aria-current="page">#{{ invoice.last_id}}</li>
          </ol>
        </nav>
     </div>

    <div class=" " v-if="is_load">
      <div  no-body class="section_header mobile_div">
        <div class="row d-flex justify-content-center">
          <h4 >Счет #{{ invoice.last_id }}</h4>
        </div>
        <div class="row no-gutters mt-3">
          <div class="col-12 col-md-8   invoice_order ">


            <div class="block_row" v-if="!(invoice.type=='shop' && order && order.order  && order.order.status && order.order.status['is_wait'] && order.order.status['is_wait']==1) && type=='client' && invoice.ispay==0 && invoice.payment_data && !(invoice.payment_data.url_pay) && invoice.payment_data.comment && invoice.currency=='TON'">
              <p class="ml-2 mt-2 text-center">Для оплаты, вам необходимо сначало подключить кошелек. А потом оплатить с помощью кнопки ниже:</p>
              <p class="ml-2 mt-2 text-center">После оплаты подождите 5-10 минут, и статус оплаты изменится.</p>


              <p class="text-center"><button class="btn btn-sm" v-if="is_show_btn_connect_ton_wallet" @click="connectWallet" id="TON_PAYMENT_BTN">Подключить<br/>кошелек</button></p>
              <p class="text-center"><button class="btn btn-sm" @click="startTonPayment" v-if="is_show_btn_pay_ton_wallet && start_ton_payment==false">Оплатить {{ invoice.sum }} {{ invoice.currency}}</button></p>
              <p class="text-center"><button class="btn btn-sm" @click="walletDisconnect" v-if="is_show_btn_pay_ton_wallet && start_ton_payment==false">Отключить</button></p>
              <div v-if="is_ton_payment_err" class="alert alert-warning">
                <h2>Ошибка при оплате!</h2>
                <p>При оплате через TonConnect произошла ошибка!</p>
              </div>
              <div v-if="start_ton_payment">
                <h2 class="text-center">Внимание!</h2>
                <p class="text-center">После того как вы сделали оплату, подождите 5-10 минут. И обновите эту страницу.</p>
              </div>


            </div>
            <div class="table-responsive">
            <table class="table     table-cart table-striped table-">
              <tbody>
              <tr v-if="!(invoice.type=='shop' && order && order.order  && order.order.status && order.order.status['is_wait'] && order.order.status['is_wait']==1) && type=='client' && invoice.ispay==0 && invoice.payment_data && invoice.payment_data.url_pay">
                <td colspan="2">Оплата</td>

              </tr>
              <tr v-if="(invoice.type && (invoice.type=='every_month' || invoice.type=='every_year'))">
                <td colspan="2"><span v-if="invoice.type=='every_month'" class="badge badge-info">ежемесячный платеж</span>
                  <span v-if="invoice.type=='every_year'" class="badge badge-info">ежегодний платеж</span>
                </td>
              </tr>
              <tr v-if="(invoice.type && invoice.service_start_at && invoice.service_end_at &&  (invoice.type=='every_month' || invoice.type=='every_year'))">
                <td colspan="2"><p><b>оплата за период</b></p>
                </td>
              </tr>
              <tr v-if="(invoice.type && invoice.service_start_at && invoice.service_end_at &&  (invoice.type=='every_month' || invoice.type=='every_year'))">
                <td colspan="2"><b><b>{{ invoice.service_start_at }}</b> - {{ invoice.service_end_at }}</b>
                </td>
              </tr>

              <tr v-if="!(invoice.type) || (invoice.type && (invoice.type=='one' || invoice.type=='every_month' || invoice.type=='every_year'))">
                <td colspan="2">Счет в&nbsp;<router-link tag="a" :to="{name: 'project_list_invoices', params: { id: invoice.project_id }}" >
                  проекте</router-link> </td>
              </tr>
              <tr v-if="!(invoice.type=='shop' && order && order.order  && order.order.status && order.order.status['is_wait'] && order.order.status['is_wait']==1) && type=='client' && invoice.ispay==0 && invoice.payment_data && invoice.payment_data.url_pay">
                <td colspan="2"> <a class="btn btn-sm" :href="invoice.payment_data.url_pay">{{ invoice.payment_data.title}}</a></td>

              </tr>

              <tr>
                <td>Дата</td>
                <td>{{ invoice.created_at }}</td>
              </tr>
              <tr v-if="type=='developer' && invoice.partner_user && invoice.partner_user.last_id">
                <td>Кто<br/>привел:</td>
                <td><router-link tag="a" :to="{name: 'user_page_main', params: { user_id: invoice.partner_user.last_id }}" class=" btn btn-sm">
                  {{ invoice.partner_user.name}}</router-link></td>
              </tr>
              <tr>

                <td colspan="2"><b>Описание</b><br/>
                  <p v-html="invoice.title.replace(/\n/g, '<br />')"> </p></td>
              </tr>
              <tr>
                <td>К оплате</td>
                <td>{{ invoice.sum }} <i>{{ invoice.currency }}</i></td>
              </tr>
              <tr v-if="invoice.ispay==1 && invoice.type!='shop'">
                <td colspan="2"><span class="badge badge-info">счет оплачен</span></td>
              </tr>

              <tr v-if="isManual==false && invoice.developer.account && invoice.ispay==0 && !(invoice.type=='shop' && order && order.order  && order.order.status && order.order.status['is_wait'] && order.order.status['is_wait']==1) ">
                <td >Реквизиты</td>
                <td> <p><mark v-if="account_parsed.number.length>0">{{ account_parsed.number.join(" ") }}</mark> <button class="btn btn-sm" v-if="account_parsed.number.length>0"  @click="copyAccount(account_parsed.number.join(''))"><i class="fa fa-copy"></i></button> {{ account_parsed.text }}</p>
                  <p v-if="success_copy"><i>скопировано</i></p></td>
              </tr>

              <tr v-if="invoice.developer.account==null && isManual==false && invoice.ispay==0 && !(invoice.payment_data && invoice.payment_data.url_pay)">
                <td colspan="2">Исполнитель не заполнил реквизиты!</td>
              </tr>
              <tr v-if="type=='client' && invoice.developer">

                <td colspan="2"  ><router-link tag="a" :to="{name: 'user_page_main', params: { user_id: invoice.developer.last_id }}" class=" btn btn-sm">
                  {{ invoice.developer.name}}</router-link></td>
              </tr>
              <tr v-if="type=='developer' && invoice.client">

                <td colspan="2"><router-link tag="a" :to="{name: 'user_page_main', params: { user_id: invoice.client.last_id }}" class=" btn btn-sm">
                  {{ invoice.client.name}}</router-link></td>
              </tr>

              <tr v-if="invoice.ispay==1 && invoice.is_complete==0 && type=='client'">
                <td colspan="2">
                  <div class="alert alert-warning">
                    <p>Внимание! Для того чтобы деньги поступили на счет исполнителя, вам необходимо нажать кнопку ниже! Делайте это только если все вас устраивает!</p>
                    <p><button class="btn btn-second" @click="unfreezeMoney()">Подтвердить</button></p>
                  </div>
                </td>
              </tr>
              <tr v-if="invoice.ispay==1 && invoice.is_complete==0 && type=='developer'">
                <td colspan="2">
                  <div class="alert alert-warning">
                   <p>Внимание ваши средства {{ invoice.currency }} {{ invoice.sum }} заморожены. Для того чтобы вы их смогли вывести, вам необходимо попросить подтвердить клиента</p>
                  </div>
                </td>
              </tr>
              <tr v-if=" invoice.ispay==1   && ((type=='developer' && invoice.developer_is_review==0 ) || (type=='client' && invoice.client_is_review==0) )">
                <td colspan="2">
                  <p v-if="type=='developer'"><router-link class="btn"     tag="a"
                      :to="{name: 'user_page_addreview', params: { user_id: invoice.client_id }}" >Оставить отзыв</router-link></p>
                  <p v-if="type=='client'"><router-link class="btn"     tag="a"
                      :to="{name: 'user_page_addreview', params: { user_id: invoice.developer_id }}" >Оставить отзыв</router-link></p>
                </td>
              </tr>


              </tbody>
            </table>
            <table class="table   table-responsive-sm table-cart table-striped" v-if="order.order">
              <tbody>
              <tr v-if="order.order && order.items && order.items.length>0">
                <td colspan="2">
                  <p v-if="invoice.ispay==1">заказ {{ invoice.last_id}} оплачен</p>
                  <p v-if="invoice.ispay==0">заказ {{ invoice.last_id}} неоплачен</p>
                </td>
              </tr>
              <tr v-if="order.order && order.items && order.items.length>0 && order.order.client_data &&  Object.keys(order.order.client_data).length>0">
                <td colspan="2">
                  Данные клиента
                </td>
              </tr>
              <tr v-if="order.order && order.items && order.items.length>0 && order.order.client_data &&  Object.keys(order.order.client_data).length>0 " v-for="(client_field,client_field_key) in order.order.client_data" :key="client_field_key">
                <td colspan="2" v-if="client_field_key!='phone'">
                  <b>{{ client_field.title}}</b>:<br>
                {{ client_field.value}}
                </td>
                <td colspan="2" v-if="client_field_key=='phone'">
                  <b>{{ client_field.title}}</b>:<br>
                  <a :href="'tel:'+client_field.value">{{ client_field.value}}</a>
                </td>


              </tr>
              <tr v-if="order.order && order.items && order.items.length>0">
                <td colspan="2">содержимое заказа</td>

              </tr>
              <tr v-if="order.order && order.items && order.items.length>0" v-for="(item,item_key) in order.items" :key="item_key">
                <td colspan="2">
                  <p><b>{{ item.title}} </b> - {{ item.custom_price}} {{ item.currency}}</p>
                  <p v-if="item.variant && item.variant.title"><b>[{{item.variant.title}}]</b></p>
                  <br>
                  <p v-if="item.confirm_options.length>0" v-for="(confirm_option,cf_key) in item.confirm_options" :key="cf_key">
                    <b>{{  confirm_option.title}}</b>

                  </p>
                  <br>
                  <p>Итого {{ item.custom_price}} x {{ item.count}} = {{ item.total_price}} {{ item.currency}} </p>
                </td>

              </tr>
              <tr v-if="order.order && order.order.discount_price && order.order.discount_price>0">
                <td colspan="2">
                  <p><b>Скидка</b> -{{order.order.discount_price}} {{ invoice.currency}}</p>

                </td>
              </tr>
              <tr v-if="order.order && order.order.delivery">
                <td colspan="2">
                  <p><b>Способ доставки</b></p>
                  <p><b> {{ order.order.delivery.title }}</b> - {{ order.order.delivery_price }} {{ invoice.currency}}</p>
                  <p>{{ order.order.delivery.description}}</p>
                </td>
              </tr>


              </tbody>
            </table>
            </div>









            <div class="p-3 section_gray_bg" v-if="order.order && order.items && order.items.length>0">




              <div class="col-md-12 center-block mt-5" >
                <h3>Общение:</h3>
                <CommentBlock  v-if="order.comments && order.comments.length>0" v-for="(comment,comment_index) in order.comments" :key="comment.last_id"  :isRemove="false"   :comment="comment"/>


                <h6>Написать комментарий</h6>
                <div class="alert alert-danger" v-if="new_comment_is_error==true">
                  <p>{{ new_comment_error }}</p>
                </div>


                <FormCommentBlock    :is_start_send="start_send_comment"  :comment_text="newComment.comment"

                    @click_button="(subcomment_text) => {


                  sendComment(subcomment_text);
                } "  :isCanEditorJs="false" :user="user"></FormCommentBlock>

              </div>
            </div>



          </div>

          <div class="col-12 col-md-4 order-first order-sm-first order-md-last">









            <div class="table-responsive">
            <table class="table   table-cart table-striped">
              <tr v-if="type=='client' && order && order.order && invoice.type=='shop' &&  order.order.status">

                <td colspan="2"><b>Статус</b>:<br><badge type="default">{{ order.order.status.title}}</badge></td>
              </tr>
              <tr v-if="!(invoice.type=='shop' && order && order.order  && order.order.status && order.order.status['is_wait'] && order.order.status['is_wait']==1) && isManual==false && type=='developer'  && invoice.ispay==0">
                <td>
                  <base-button v-if="!(invoice.payment_data && invoice.payment_data.percent) && !(invoice.type=='shop' && order && order.order  && order.order.status && order.order.status['is_wait'] && order.order.status['is_wait']==1) && isManual==false && type=='developer'  && invoice.ispay==0"
                      @click="invoiceFinishPay()" type="default" size="sm"
                      class="">Я получил деньги
                  </base-button>
                </td>
              </tr>
              <tr v-if="!(invoice.type=='shop' && order  &&  order.order  && order.order.status && order.order.status['is_wait'] && order.order.status['is_wait']==1) && type=='client' && invoice.client_pay==0 && invoice.ispay==0 && isManual==false">
                <td colspan="2"><base-button v-if="!(invoice.payment_data && invoice.payment_data.percent) && !(invoice.type=='shop' && order  &&  order.order  && order.order.status && order.order.status['is_wait'] && order.order.status['is_wait']==1) && type=='client' && invoice.client_pay==0 && invoice.ispay==0 && (isManual==false)" @click="invoiceSetPay()" type="info" size="sm"
                    class="">Я оплатил счет
                </base-button></td>
              </tr>

              <tr v-if="type=='developer' && invoice.type=='shop' && (invoice.ispay==1 )">

                <td colspan="2"> <select @change="setNewStatus" class="w-100 form-control" v-model="order.order.status_id" v-if="type=='developer' && invoice.type=='shop' && (invoice.ispay==1 )" >
                  <option   v-for="(status,status_key) in order.statuses" :key="status_key"
                      v-if="order.statuses.length>0" :value="status.last_id">{{ status.title}}</option>
                </select></td>

              </tr>
              <tr v-if="type=='developer' && (order && order.order && order.order['status'] && invoice.ispay==0)">
                <td colspan="2">
                  <badge v-if="type=='developer' && (order && order.order && order.order['status'] && invoice.ispay==0)">{{ order.order.status.title}}</badge>
                </td>
              </tr>
              <tr v-if="( (type=='developer'  && invoice.ispay==0 && isManual==false) && (type=='developer' && (order && order.order && order.order['status'] && order.order['status']['is_wait'] && order.order['status']['is_wait']==1)) )">
                <td v-if="type=='developer'  && invoice.ispay==0 && isManual==false"><base-button @click="invoiceDelete()" v-if="type=='developer'  && invoice.ispay==0 && isManual==false && !(invoice.payment_data && invoice.payment_data.percent)" type="danger" size="sm">Удалить<br> счет</base-button></td>
                <td v-if="type=='developer' && (order && order.order && order.order['status'] && order.order['status']['is_wait'] && order.order['status']['is_wait']==1)">
                  <button   class=" btn btn-sm" @click="setConfirmOrder" v-if="type=='developer' && (order && order.order && order.order['status'] && order.order['status']['is_wait'] && order.order['status']['is_wait']==1)">подтвердить<br>заказ</button>
                </td>
              </tr>
              <tr v-if=" !(invoice.payment_data && invoice.payment_data.percent) && ( (type=='developer'  && invoice.ispay==0 && isManual==false) && !(type=='developer' && (order && order.order && order.order['status'] && order.order['status']['is_wait'] && order.order['status']['is_wait']==1)) )">
                <td colspan="2"><base-button @click="invoiceDelete()" v-if="type=='developer'  && invoice.ispay==0 && isManual==false" type="danger" size="sm">Удалить<br>счет</base-button></td>
              </tr>
              <tr v-if="( !(type=='developer'  && invoice.ispay==0 && isManual==false) && (type=='developer' && (order && order.order && order.order['status'] && order.order['status']['is_wait'] && order.order['status']['is_wait']==1)) )">
                <td colspan="2"><button   class="btn btn-sm" @click="setConfirmOrder" v-if="type=='developer' && (order && order.order && order.order['status'] && order.order['status']['is_wait'] && order.order['status']['is_wait']==1)">подтвердить<br> заказ</button></td>
              </tr>
              <tr v-if="type=='developer' && invoice.ispay==1">
                <td> <badge v-if="type=='developer' && invoice.ispay==1" type="info">счет оплачен</badge></td>
              </tr>
            </table>
            </div>


          </div>

        </div>




      </div>
      </div>


  </section>
</template>
<script>
import {eventBus} from "@/main";
import axios from "axios";
import Vue from "vue";
import Api from "@/models/Api";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import CommentBlock from "@/components/Custom/CommentBlock";
import FormCommentBlock from "@/components/Custom/FormCommentBlock";
import UserCard from "@/components/Custom/UserCard";
import UserModel from "../../models/UserModel";

export default {
  data() {
    return {
      "type": "client",
      'invoice': null,
      'order':null,
      'is_load': false,
      'start_send_comment':0,
      "image_url":"",
      "newreview": {
        "review": null,
        "rating": null,
      },
      "new_comment_is_error":false,
      "new_comment_error":"",
      "newComment":{
        "comment":""
      },
      'account_parsed':null,
      "success_copy":false,
      'isManual':false,
      "is_error": false,
      "error_message": null,
      "type_currencys":[],
      "currencys_title":[],
      'tonConnectUI':null,
      'is_show_btn_connect_ton_wallet':true,
      'is_show_btn_pay_ton_wallet':false,
      'is_ton_payment_err':false,
      'start_ton_payment':false,


    }
  },
  methods: {
   async copyAccount(number_card){
     var app=this;
      try {
        await navigator.clipboard.writeText(number_card);
        app.success_copy=true;
      } catch (error) {
        console.error(error.message);
      }
    },
   replaceNumbersWithLinks(text) {
     const parts = text.split(' ');

     // Создаем новый массив для хранения преобразованных частей текста
     const transformedParts = [];
     const numericParts=[]
     const textParts=[]

     // Перебираем части текста
     for (let i = 0; i < parts.length; i++) {
       // Если это число, добавляем его в массив
       if (!isNaN(parts[i])) {
         numericParts.push(parts[i]);
       } else {
         textParts.push(parts[i]);

       }
     }

     // Соединяем преобразованные части текста в новую строку
     const transformedText = numericParts.join(" ",)+" "+textParts.join(" ");
    var result={};

    result['number']=numericParts;
    result["text"]=textParts.join(" ");
     // Возвращаем преобразованный текст
     return result
    },
    load_script (url) {
      let self = this
      return new Promise((resolve, reject) => {

        // if script is already loading via another component
        if ( self.is_script_loading ){
          // Resolve when the other component has loaded the script
          this.$root.$on('script_loaded', resolve)
          return
        }

        let script = document.createElement('script')
        script.setAttribute('src', url)
        script.async = true

        this.$root.$emit('loading_script')

        script.onload = () => {
          /* emit to global event bus to inform other components
           * we are already loading the script */
          this.$root.$emit('script_loaded')
          resolve()
        }

        document.head.appendChild(script)

      })

    },
    sendComment(сomment_text){
      event.preventDefault();
      var app = this;
      app.newComment.comment=сomment_text;
      var newComment = app.newComment;
      //newComment.comment=сomment_text;
      app.start_send_comment=1;
      Api.addShopOrderComment(newComment, app.invoice.last_id,app.order.order.id, function (result_comment) {
        app.new_comment_is_error = false;
        app.start_send_comment=0;
        app.newComment.comment = "";
        app.order.comments.push(result_comment)
      }, function (message) {
        app.start_send_comment=0;
        app.new_comment_is_error = true;
        app.new_comment_error = message;
      })
    },
    invoiceDelete(){
      var app = this;
      var id = app.invoice.last_id;
      Api.deleteInvoice(id,function(){
        app.$router.push({"name": "invoices"});

      },function(err){
        alert(err);
      })
    },
    unfreezeMoney(){
      var app = this;
      var id = app.invoice.last_id;
      Api.invoiceUnFreeze(id, function () {
        app.invoice.ispay = 1;
        app.is_load=false;

        Api.loadInvoice(id,function(data){
          app.isManual=data.ismanual;
          app.user = data.user;
          app.order=data.order;
          app.invoice = data.invoice;
          if (app.user.last_id == data.invoice.developer_id) {
            app.type = "developer";
          }
          if (app.user.last_id == data.invoice.client_id) {
            app.type = "client";
          }

          app.is_load = true;
        });

      })
    },
    invoiceFinishPay() {
      var app = this;
      var id = app.invoice.last_id
      Api.invoiceFinishPay(id, function () {
        app.invoice.ispay = 1;
        app.is_load=false;

        Api.loadInvoice(id,function(data){
          app.isManual=data.ismanual;
          app.user = data.user;
          app.order=data.order;
          app.invoice = data.invoice;
          if (app.user.last_id == data.invoice.developer_id) {
            app.type = "developer";
          }
          if (app.user.last_id == data.invoice.client_id) {
            app.type = "client";
          }

          app.is_load = true;
        });

      })

    },
    sendReview() {
      var app = this;
      Api.sendReview(app.newreview, app.invoice.last_id, function (data) {
        app.invoice = data.invoice;
      }, function (message) {
        app.is_error = true;
        app.error_message = message;
      })
    },
    changeRate(evt, props) {
      this.newreview.rating = props.rating;
    },
    setConfirmOrder(){
      var app=this;
      app.order.order.status_id=app.order.status_confirm.last_id;
      app.order.order.status=app.order.status_confirm;
      var status = app.order.order.status_id;
      Api.setShopNewStatus(status, app.invoice.last_id,app.order.order.id, function () {

      });
    },
    setNewStatus() {
      var app = this;
      var status = app.order.order.status_id;
      Api.setShopNewStatus(status, app.invoice.last_id,app.order.order.id, function () {

      });
    },
    invoiceSetPay() {

      var app = this;
      var id = app.invoice.last_id
      Api.invoiceSetPay(id, function () {
        app.invoice.client_pay = 1;
      });

    },
    async initTonConnect(){

      var app=this;
      var sum=app.invoice.sum;

      var url_manifest=Vue.config.BASE_URL_FRONT+'tonconnect-manifest.json';





      if(UserModel.isTWA()){

        var url_back=app.invoice.payment_data.return_back_app;

        //url_back="https://t.me/durov";

        app.tonConnectUI = new TON_CONNECT_UI.TonConnectUI({
          manifestUrl: url_manifest,
          twaReturnUrl: url_back,
          language: 'ru',
          actionsConfiguration:{
            'returnStrategy':url_back
          }
        });

        // app.tonConnectUI = new TON_CONNECT_UI.TonConnectUI({
        //   manifestUrl: url_manifest,
        //   twaReturnUrl: url_back,
        //
        // });



        app.is_load = true;
      }else {
        app.tonConnectUI = new TON_CONNECT_UI.TonConnectUI({
          manifestUrl: url_manifest,
          language: 'ru'

        });
        app.is_load = true;
      }


      const walletsList = await app.tonConnectUI.getWallets();
      const unsubscribe = app.tonConnectUI.onStatusChange(
          walletAndwalletInfo => {

              app.is_show_btn_connect_ton_wallet=false;
              app.is_show_btn_pay_ton_wallet=true;
            // update state/reactive variables to show updates in the ui
          }
      );

    },
    async startTonPayment(){
      var app=this;
      var invoice_comment=app.invoice.payment_data.invoice_comment;
      let a = new TonWeb.boc.Cell();
      a.bits.writeUint(0, 32);
      a.bits.writeString(invoice_comment);
      let payload = TonWeb.utils.bytesToBase64(await a.toBoc());
      var sum=app.invoice.sum;

      var transaction = {
        validUntil: Math.floor(Date.now() / 1000) + 60, // 60 sec
        messages: [
          {
            address: app.invoice.payment_data.adress,
            amount: sum*1000000000,
            payload:payload
            // stateInit: "base64bocblahblahblah==" // just for instance. Replace with your transaction initState or remove
          },

        ]
      }
      if(app.invoice.payment_data.first_adress && app.invoice.payment_data.percent){
        var admin_percent=app.invoice.sum / 100 * app.invoice.payment_data.percent;
        var final_sum=sum-admin_percent;
        var transaction = {
          validUntil: Math.floor(Date.now() / 1000) + 60, // 60 sec
          messages: [
            {
              address: app.invoice.payment_data.first_adress,
              amount: final_sum*1000000000,
              payload:payload
              // stateInit: "base64bocblahblahblah==" // just for instance. Replace with your transaction initState or remove
            },
            {
              address: app.invoice.payment_data.adress,
              amount: admin_percent*1000000000,

              // stateInit: "base64bocblahblahblah==" // just for instance. Replace with your transaction initState or remove
            },

          ]
        }

      }

      try{
        app.start_ton_payment=true;
        var options_send={
          modals: ['before', 'success', 'error'],
          notifications: ['before', 'success', 'error']
        };

        if(UserModel.isTWA()){

         //options_send["returnStrategy"]=app.invoice.payment_data.return_back_app
        }
        const result = await app.tonConnectUI.sendTransaction(transaction,options_send);
        app.is_ton_payment_err=false;
      }catch(err){
        app.start_ton_payment=false;
        app.is_ton_payment_err=true;
        await app.walletDisconnect();



      }
    },
    async walletDisconnect(){
      var app=this;

      try{
        app.is_show_btn_connect_ton_wallet=true;
        app.is_show_btn_pay_ton_wallet=false;
        await app.tonConnectUI.disconnect();

      }catch (err){

      }

    },
    async connectWallet(){
      var app=this;
      try{
        const connectedWallet = await app.tonConnectUI.connectWallet();
        app.is_show_btn_connect_ton_wallet=false;
        app.is_show_btn_pay_ton_wallet=true;

      }catch (err){

      }

    }

  },

  async mounted() {
    var app = this;
    // try {
    //   await app.load_script('https://unpkg.com/@tonconnect/ui@latest/dist/tonconnect-ui.min.js');
    //   await app.load_script('https://unpkg.com/tonweb@0.0.41/dist/tonweb.js');
    // }catch(err){
    //
    // }




    let id = app.$route.params.id;
    app.image_url = Vue.config.IMAGE_URL;
    Api.loadInvoice(id,async function(data){
      app.isManual=data.ismanual;
      app.user = data.user;
      app.order=data.order;
      app.invoice = data.invoice;
      if(app.invoice.developer.account){
        app.account_parsed=app.replaceNumbersWithLinks(app.invoice.developer.account);
      }
      if (app.user.last_id == data.invoice.developer_id) {
        app.type = "developer";
      }
      if (app.user.last_id == data.invoice.client_id) {
        app.type = "client";
      }

      if(!(app.invoice.type=='shop' && app.order && app.order.order  && app.order.order.status && app.order.order.status['is_wait'] && app.order.order.status['is_wait']==1) && app.type=='client' && app.invoice.ispay==0 && app.invoice.payment_data && !(app.invoice.payment_data.url_pay) && app.invoice.payment_data.comment && app.invoice.currency=="TON"){
        try {
          await app.initTonConnect();
        }catch(err){

        }


      }else {
        app.is_load = true;
      }
    });

  },
  components: {FormCommentBlock,LoadingBlock,'CommentBlock':CommentBlock,UserCard}
}
</script>